export default "__VITE_ASSET__cES4r2O7__"